import { Box } from 'designSystem/components/Box'
import { Input } from 'designSystem/components/Input'
import styled from 'styled-components'

export const PageRangeInput = styled(Input)`
  width: 3.5rem;
  text-align: center;
  font-variant-numeric: tabular-nums;
`

export const OutlineScrollBox = styled(Box)`
  max-height: 16rem;
`
